module.exports = __webpack_public_path__ + "img/simplicity.03ab8659.png";